module.exports = __webpack_public_path__ + "media/sub5-1.2dc994c3.mp4";